import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { numberOfRooms, roomsToConfigurationObject } from '@daedalus/core/src/room/business/roomConfiguration';
import { Room, RoomOffer } from '@findhotel/sapi';
import { guestPickerMessages } from '../../../search/GuestPicker/guestPickerMessages';
import { RoomLabels } from './RoomLabels';
interface Props {
  roomsSplit: string;
  numberOfNights: number;
  room: Room | undefined | null;
  offer: RoomOffer | undefined | null;
}
const _exp = /*#__PURE__*/() => Text;
const RoomTitle = /*#__PURE__*/styled(_exp())({
  name: "RoomTitle",
  class: "ro4qivu",
  propsAsIs: true
});
const CenteredDot = /*#__PURE__*/styled('span')({
  name: "CenteredDot",
  class: "chnaz6i",
  propsAsIs: false
});
export const RoomDetail = ({
  roomsSplit,
  numberOfNights,
  room,
  offer
}: Props) => {
  const {
    formatMessage
  } = useIntl();
  if (!room) return null;
  const roomsNumber = numberOfRooms(roomsSplit);
  const roomObject = roomsToConfigurationObject(roomsSplit);
  const guestsNumber = roomObject.numberOfAdults + roomObject.numberOfChildren;
  const guestMessage = formatMessage(guestPickerMessages.guest, {
    count: guestsNumber
  });
  const roomsMessage = formatMessage(guestPickerMessages.room, {
    count: roomsNumber
  });
  const guestsText = guestsNumber ? guestMessage : null;
  const commaText = guestsNumber && roomsNumber ? <CenteredDot>.</CenteredDot> : null;
  const roomsText = roomsNumber ? roomsMessage : null;
  const {
    name
  } = room;
  return <ContentWrapper paddingTop="s400">
      <RoomTitle variant="titleM">{name}</RoomTitle>
      <Text variant="bodyS" colorPath="content.neutral.c600">
        <FormattedMessageWrapper id="numberOfNights" defaultMessage="{count, plural, one {1 night} other {# nights}}" values={{
        count: numberOfNights
      }} />
        <CenteredDot>.</CenteredDot>
        {guestsText}
        {commaText}
        {roomsText}
      </Text>
      {offer && <RoomLabels offer={offer} />}
    </ContentWrapper>;
};

require("./RoomDetail.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomDetail.tsx");